import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { VueFreshchat } from "./plugins/freshchat/freshchat";

import "@/assets/main.scss";

// Alpha version of error reporting
window.onerror = (msg, url, lineNo, columnNo, error) => {
  const xhttp = new XMLHttpRequest();
  xhttp.open(
    "POST",
    "https://client-public-logger-qbldqqbx7a-nw.a.run.app/log",
    true
  );
  xhttp.setRequestHeader("Content-Type", "application/json");
  if (error && error.stack) {
    xhttp.send(
      JSON.stringify({
        logs: [
          {
            level: "error",
            message: `Uncaught error: ${msg} in url ${url}\n${error.stack}`
          }
        ]
      })
    );
  } else {
    xhttp.send(
      JSON.stringify({
        logs: [
          {
            level: "error",
            message: `Uncaught error: ${msg}\n url ${url}\n Line: ${lineNo}`
          }
        ]
      })
    );
  }
};

const app = createApp(App);

Sentry.init({
  app,
  dsn:
    "https://15a282b7ebf54b0b9cf1e7a53d3f1101@o252297.ingest.sentry.io/5758498",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "dar.snoofa.com", /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});

app
  .use(router)
  .use(store)
  .use(VueFreshchat, {
    appToken: "2e02fa73-9cf7-4926-bdc8-bc0fb56d868b",
    host: "https://wchat.eu.freshchat.com"
  })
  .mount("#app");
